module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tweetPictures"
    }
  }, [_c('div', {
    staticClass: "faultClass container"
  }, [_c('h4', [_vm._v("权益池管理")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.dataList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultClassListPart listPart"
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n        "), _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editInfo(item)
        }
      }
    }, [_vm._v("编辑")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": _vm.addInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2)]), _vm._v(" "), _c('biz-privilege-pool-info', {
    ref: "infoRef",
    on: {
      "refresh": _vm.loadPage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-00794055","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/privilege/pool/index.vue
// module id = 1567
// module chunks = 0